import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/north.css";
import "../assets/css/home.css";
import hero1 from "../assets/TIG Website Images/Our Businesses/Elevate/elevate.png";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaUsers,
  FaBuilding,
  FaLightbulb,
  FaUserTie,
  FaChartBar,
  FaComments,
  FaTachometerAlt,
  FaBriefcase,
} from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import buildingImg from "../assets/bank-3.jpg"; 
import bank1 from "../assets/bank-2.jpg"; 
import { Container, Row, Col } from "react-bootstrap";
export default function NorthStar() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const specializations = [
    {
      title: "Banking Skills Services",
      icon: <FaUsers className="fs-1 text-primary" />,
      text: "We provide advanced training in core and Islamic banking operations, empowering professionals with modern financial practices and boosting workforce competencies for long-term success in a competitive sector.",
    },
    {
      title: "Innovation",
      icon: <FaBuilding className="fs-1 text-primary" />,
      text: "Our customized innovation programs are designed to foster creativity, strategic thinking, and leadership, ensuring organizations stay ahead in today's rapidly evolving business landscape.",
    },
    {
      title: "Islamic Banking",
      icon: <FaLightbulb className="fs-1 text-primary" />,
      text: "We develop skill-building initiatives aligned with national development goals, focusing on ethical banking practices and innovative financial solutions tailored for the public sector.",
    },
    {
      title: "Leadership Programs",
      icon: <FaUserTie className="fs-1 text-primary" />,
      text: "Our expert-led leadership workshops help professionals enhance decision-making, conflict resolution, and team management capabilities for organizational growth.",
    },
    {
      title: "Sales Training",
      icon: <FaChartBar className="fs-1 text-primary" />,
      text: "We provide practical sales training to equip businesses with tools and strategies for boosting productivity, building customer relationships, and achieving revenue growth.",
    },
    {
      title: "Soft Skills",
      icon: <FaComments className="fs-1 text-primary" />,
      text: "Our training modules cover communication, negotiation, emotional intelligence, and workplace collaboration to support career development.",
    },
    {
      title: "Performance Management",
      icon: <FaTachometerAlt className="fs-1 text-primary" />,
      text: "We deliver programs designed to help organizations set clear KPIs, monitor progress, and implement effective performance management strategies.",
    },
    {
      title: "Corporate Workshops",
      icon: <FaBriefcase className="fs-1 text-primary" />,
      text: "Our tailored corporate workshops address real business challenges through interactive sessions that promote problem-solving and collaboration.",
    },
  ];

  // Slick carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    customPaging: () => <div className="custom-dot"></div>,
    dotsClass: "slick-dots custom-dots",
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };
const steps = [
    {
      id: "01",
      title: "Understanding Requirements",
      description:
        "We begin by building strong relationships with our clients to understand exact resource and operational needs. This step involves close interaction between our Operations, HR, and Legal teams, ensuring clarity before execution.",
      link: "#",
    },
    {
      id: "02",
      title: "Strategic Sourcing & Shortlisting",
      description:
        "We provide carefully filtered CVs from our large internal database of experienced professionals. TIG ensures a fast turnaround by handling documentation, contracts, and compliance with Omanization and legal standards.",
      link: "#",
    },
    {
      id: "03",
      title: "Deployment & Ongoing Support",
      description:
        "Once placed, TIG staff are fully supported with payroll processing, leave tracking, and insurance — seamlessly integrated with your team. Clients are free to focus on core business while TIG handles daily workforce management.",
      link: "#",
    },
  ];
  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid p-0">
        <div
          className="hero-section"
          style={{ backgroundImage: `url(${hero1})` }}
        >
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <p className="text-uppercase text-light m-0">
                EXPERIENCE & EXPERTISE
              </p>
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                Elevate Management Services LLC
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Our Specializations Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-3">
            <h2 className="fw-bold">Our Specializations</h2>
            <p className="text-muted fs-5">
              Who is Elevate Management Services LLC suitable for?
            </p>
          </div>

          {/* Slick Carousel */}
          <Slider {...settings}>
            {specializations.map((item, index) => (
              <div key={index} className="p-3 d-flex" data-aos="fade-up">
                <div className="p-4 text-center bg-white-data shadow-sm rounded h-100 flex-fill d-flex flex-column">
                  <div className="mb-3">
                    {item.icon} {/* React Icon directly here */}
                  </div>
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="text-muted flex-grow-1">{item.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      <section className="py-5">
        <Container>
          <Row className="align-items-center" >
            {/* Left Image */}
            <Col lg={6} className="mb-4 mb-lg-0"  data-aos="fade-up">
              <img
                src={buildingImg}
                alt="Workforce Excellence"
                className="img-fluid rounded shadow"
              />
            </Col>

            {/* Right Content */}
          <Col lg={6} className="px-4">
  <h2 className="fw-bold mb-3" data-aos="fade-up" >
    We Empower Your <br/> Workforce With Excellence
  </h2>

  <p className="text-muted mb-4 fs-5" data-aos="fade-up" >
    Elevate Management Services LLC is committed to enhancing
    organizational performance through tailored learning and
    development programs across sectors.
  </p>

  <div className="mb-3 d-flex" data-aos="fade-up" >
    <FaCheckCircle className="text-primary mt-1 me-2 fs-3" />
    <div>
      <h5 className="fw-bold mb-1">Professional Banking Skills</h5>
      <p className="mb-0 text-muted fs-para">
        Training in corporate & Islamic banking, investment
        practices, and service excellence — curated by industry
        veterans.
      </p>
    </div>
  </div>

  <div className="d-flex" data-aos="fade-up" >
    <FaCheckCircle className="text-primary mt-1 me-2 fs-3" />
    <div>
      <h5 className="fw-bold mb-1">Customized Learning Solutions</h5>
      <p className="mb-0 text-muted fs-para">
        Flexible and industry-aligned modules developed by experts
        with 100+ years of combined experience in India and the
        Middle East.
      </p>
    </div>
  </div>
</Col>

          </Row>
        </Container>
      </section>
      <section className="mb-3" style={{ backgroundColor: "#0a2540" }}>
  <Row className="align-items-center text-white g-0 m-0 p-0">
    
    {/* Right Image - Full width, no padding/margin */}
    <Col lg={6} className="p-0 m-0" data-aos="fade-up">
      <img
        src={bank1}
        alt="Business Consulting"
        className="w-100 h-100"
        style={{
          objectFit: "cover",
          minHeight: "480px",
          display: "block",
        }}
      />
    </Col>
    {/* Left Content */}
    <Col lg={6} className="p-5" data-aos="fade-up">
      <h6 className="text-uppercase text-light mb-2">Business Consulting</h6>
      <h2 className="fw-bold mb-4">
        The right skills for a smarter organizational future
      </h2>

      <div className="mb-4 d-flex" data-aos="fade-up">
        <FaCheckCircle className="text-danger mt-1 me-3 fs-4" />
        <div>
          <h5 className="fw-bold mb-1">Training & Skill Development</h5>
          <p className="mb-0 text-light">
            Industry-focused programs in banking, sales, and soft skills,
            crafted by globally experienced professionals.
          </p>
        </div>
      </div>

      <div className="mb-4 d-flex" data-aos="fade-up">
        <FaCheckCircle className="text-danger mt-1 me-3 fs-4" />
        <div>
          <h5 className="fw-bold mb-1">Customized Corporate Workshops</h5>
          <p className="mb-0 text-light">
            Tailored sessions aligned with business goals to boost team
            performance and adaptability.
          </p>
        </div>
      </div>

      <div className="d-flex" data-aos="fade-up">
        <FaCheckCircle className="text-danger mt-1 me-3 fs-4" />
        <div>
          <h5 className="fw-bold mb-1">Strategic Workforce Planning</h5>
          <p className="mb-0 text-light">
            Expert support in building talent pipelines and long-term
            growth strategies.
          </p>
        </div>
      </div>
    </Col>

  </Row>
</section>

  
 
    </>
  );
}
